import { requestFileDocumentSupport } from '../../../utils/api';
import { ACTION, FAILED, LOADING, RESET, SUCCESS } from './constants';

export function fetchRequestFile(payload, callback = () => {}) {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'RequestFile';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await requestFileDocumentSupport(payload);
      dispatch(successAction(data, KEY));
      callback({
        success: true
      });
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
      callback({
        success: true,
        status: error.status
      });
    }
  };
}

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message) {
  return { type: SUCCESS, data, key, message: message };
}

export function setAction(data) {
  return { type: ACTION, data };
}
export function reset(key) {
  return { type: RESET, key };
}
export const clearRedux = (key)  => {
  return async(dispatch) => {
    dispatch(reset(key));
  };
};
